import { render, staticRenderFns } from "./MedicineGroupsSelectbox.vue?vue&type=template&id=69652d5a"
import script from "./MedicineGroupsSelectbox.vue?vue&type=script&lang=js"
export * from "./MedicineGroupsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports